import { render } from "./CVPage.vue?vue&type=template&id=227e2d94&scoped=true"
import script from "./CVPage.vue?vue&type=script&lang=js"
export * from "./CVPage.vue?vue&type=script&lang=js"

import "./CVPage.vue?vue&type=style&index=0&id=227e2d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227e2d94"]])

export default __exports__